import GET_REWARDS from 'graph/queries/rewards/get-rewards-query';
import UPDATE_SELECTED_REWARDS from 'graph/queries/rewards/update-selected-reward';
import { QueryResult, useMutation, useQuery } from '@apollo/client';
import { useCallback } from 'react';
import { RewardsStore } from 'types';

const useRewardsStore = (): RewardsStore => {
  const { data, loading, error }: QueryResult = useQuery(GET_REWARDS, {
    fetchPolicy: 'cache-and-network',
    variables: {
      where: {
        character: {
          characterType: 'PRINT',
          characterCase: 'UPPERCASE',
        },
      },
    },
  });

  const [updateSelectedReward] = useMutation(UPDATE_SELECTED_REWARDS);
  const handleUpdateSelectedReward = useCallback(
    async (studentRewardId: number) => {
      const characterRewards = data?.studentRewards.characterRewards.find((item) =>
        item?.studentRewards.some((studentReward) => studentReward.id === studentRewardId)
      );

      const optimisticResponse = characterRewards && {
        selectStudentReward: {
          studentRewards: characterRewards.studentRewards.map((studantReward) => ({
            ...studantReward,
            selected: studantReward.id === studentRewardId,
          })),
          __typename: characterRewards.__typename,
        },
      };
      const result = await updateSelectedReward({
        variables: { data: { id: studentRewardId } },
        optimisticResponse,
      });
      return result?.data?.selectStudentReward;
    },
    [data]
  );

  return [
    {
      charactersRewards: data?.studentRewards?.characterRewards ?? [],
      instructions: data?.studentRewards?.instructions,
      loading,
      error,
    },
    {
      handleUpdateSelectedReward,
    },
  ];
};

export default useRewardsStore;
